// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/node/NodeArticle.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/node/NodeArticle.tsx");
  import.meta.hot.lastModified = "1727904225313.7651";
}
// REMIX HMR END

import { Fragment } from "react";
import { componentResolver } from "~/components/helpers/componentResolver";
import Secondary from "../layout/Secondary";
import Quaternary from "../layout/Quaternary";
export default function NodeArticleComponent({
  node,
  environment
}) {
  const isToCPage = node.showTableOfContent;
  const components = componentResolver(node.components || [], isToCPage ? "quaternary" : "secondary", environment);
  if (isToCPage) {
    return <Quaternary node={node}>
      {components.map(component => {
        return <Fragment key={component?.props.uuid}>{component}</Fragment>;
      })}
    </Quaternary>;
  }
  return <Secondary node={node}>
      {components.map(component => {
      return <Fragment key={component?.props.uuid}>{component}</Fragment>;
    })}
    </Secondary>;
}
_c = NodeArticleComponent;
var _c;
$RefreshReg$(_c, "NodeArticleComponent");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;